import { ConfigService, version } from '@igo2/core/config';

export function getAppVersion(configService: ConfigService): string {
  return (
    configService.getConfig('version.app') ||
    configService.getConfig('version.lib') ||
    version.lib
  );
}

export function printSection(sectionId) {
  const sectionToPrint = document.getElementById(sectionId);
  const clonedSectionToPrint = sectionToPrint.cloneNode(true) as HTMLElement;

  const root = document.querySelector('app-portal');

  showHideChildNodes(root);
  clonedSectionToPrint.classList.toggle('printArea');
  root.appendChild(clonedSectionToPrint);

  window.print();

  root.removeChild(clonedSectionToPrint);
  showHideChildNodes(root);
}

export function showHideChildNodes(node: Element) {
  node.childNodes.forEach(node => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const childElement = node as HTMLElement;
      childElement.classList.toggle("hide-everything");
    }
  });
}
